import React from 'react';
const SideBarLink = ({ title, onClick, icon, href, target, text }) => {
  if (!text) {
    text = title;
  }
  if (onClick) {
    return (
      <li title={title} onClick={onClick} className="gjs-tablinks">
        <i className={`wb ${icon}`}></i>
      </li>
    );
  }
  if (href) {
    return (
      <li>
        <a href={href} className="icon-link" title={title} target={target}>
          <i className={`wb ${icon}`}></i> {text}
        </a>{' '}
      </li>
    );
  }
};

export default SideBarLink;
